import { render, staticRenderFns } from "./LyftGoldandPlatinumDiscountPlanDisclosure.vue?vue&type=template&id=06fa8aa8&"
import script from "./LyftGoldandPlatinumDiscountPlanDisclosure.vue?vue&type=script&lang=js&"
export * from "./LyftGoldandPlatinumDiscountPlanDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports